module.exports = __webpack_public_path__ + "static/media/WhiteLady.50902ff6.jpg";